import { render, staticRenderFns } from "./r-select.vue?vue&type=template&id=6cb27d43&scoped=true"
import script from "./r-select.vue?vue&type=script&setup=true&lang=js"
export * from "./r-select.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-select.vue?vue&type=style&index=0&id=6cb27d43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb27d43",
  null
  
)

export default component.exports